// Shared insight image helpers — used by Insights grid + PostCard tile.

export function isKnownFallbackImageUrl(url: string): boolean {
  const n = (url || "").toLowerCase();
  return (
    n.includes("/404") ||
    n.includes("404.png") ||
    n.includes("notfound") ||
    n.includes("not-found") ||
    n.includes("oops")
  );
}

export function buildTitleImageUrl(postId: number, title: string): string {
  const normalized = title.trim().split(" ").join("");
  if (!normalized) return "";
  return `https://public.ticca.com/images/png/insight_${postId}_${normalized}.png`;
}
